import { axios } from "../helpers/axios";
import { setNoAlertStatus } from "../helpers/storage";

export type UniquePartPaload = {
  part_name: string;
  usecase_id: string;
};

// API for check unique station name
export const checkUniquePartName = (
  payload: UniquePartPaload
): Promise<any> => {
  setNoAlertStatus(true);
  return axios.post("parts/check_part_uniqueness/", payload, { suppressAlerts: { statusCode: [422] } } as any);
};

export const checkUniquePartNumber = (payload: any): Promise<any> => {
  setNoAlertStatus(true);
  return axios.post("parts/verify_part_detail/", payload);
};

// API for fetching parts along with filters
export const getAllParts = (payload: any): Promise<any> => {
  setNoAlertStatus(true);
  return axios.post(`parts/get_all_parts/`, payload);
};

// API for fetching parts along with usecase
export const getAllPartsForUsecase = (payload: any): Promise<any> => {
  setNoAlertStatus(true);
  return axios.get(`parts/get_all_parts_for_usecase/${payload}`);
};

// API for editing a part
export const editPart = (payload: any): Promise<any> => {
  setNoAlertStatus(true);
  return axios.post(`parts/edit_part/`, payload);
};

// API for fetching temp id for retrieving edge+ data
export const getTempParts = (payload: any): Promise<any> => {
  setNoAlertStatus(true);
  return axios.post(`parts/add_temp_part/`, payload);
};

// API for fetching temp id for retrieving edge+ data
export const updateTempParts = (payload: any): Promise<any> => {
  setNoAlertStatus(true);
  return axios.patch(`parts/update_temp_part/`, payload);
};

//API for creating a part without edge
export const createpartWithoutEdge = (payload: any): Promise<any> => {
  setNoAlertStatus(true);
  return axios.post(`parts/add_part_without_edge/`, payload);
};

// API for deleting an Usecase
export const deletePart = (id: string): Promise<any> => {
  return axios.delete(`parts/delete_part/${id}`);
};

// API for deleting an Usecase
export const getPartControllerData = (id: string): Promise<any> => {
  return axios.get(`parts/get_waypoint_data/${id}`);
};

// API for changing part status
export const changePartStatus = (payload: any): Promise<any> => {
  return axios.get(`parts/update_part_status/${payload}`);
};

// API for delete temp part
export const deleteTempPart = (id: string): Promise<any> => {
  return axios.delete(`parts/delete_temp_part/${id}`);
};

//API for getting part statistics
export const getPartStatistics = (id: any): Promise<any> => {
  return axios.get(`parts/get_part_statistics/${id}`);
};

// API for fetching parts for the import dataset
export const getAllPartsForImport = (payload: any): Promise<any> => {
  setNoAlertStatus(true);

  let url = `parts/get_parts_for_import/?current=${payload.current}&limit_to=${payload.limit_to}`;
  if (payload?.workstation_id) {
    url += `&workstation_id=${payload?.workstation_id}`;
  }
  if (payload?.workstation_type) {
    url += `&workstation_type=${payload?.workstation_type}`;
  }
  if (payload?.usecase_id) {
    url += `&usecase_id=${payload?.usecase_id}`;
  }
  if (payload?.search_pattern) {
    url += `&search_pattern=${payload?.search_pattern}`;
  }
  if (payload?.defect_extraction) {
    url += `&defect_extraction=true`;
  }

  return axios.get(url);
};
